import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import GoogleSignInButton from '../components/GoogleSignInButton';
import { BUILD_VERSION_TEXT } from '../buildInfo';

export default function Settings() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [connected, setConnected] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api.auth.googleStatus({ skipAuthRefresh: true }).then((res) => {
      if (active) setConnected(Boolean(res.data?.data?.connected));
    }).catch(() => {
      if (active) setError('Unable to load Google connection status.');
    }).finally(() => {
      if (active) setStatusLoading(false);
    });
    return () => { active = false; };
  }, []);

  return (
    <main style={styles.page}>
      <div style={styles.header}>
        <button onClick={() => navigate('/profile')} style={styles.back}>← Profile</button>
        <h1 style={styles.title}>Settings</h1>
      </div>

      <section style={styles.googleCard} aria-labelledby="google-account-heading">
        <div style={styles.googleHeader}>
          <div style={styles.googleIcon} aria-hidden="true">G</div>
          <div style={styles.googleHeadingCopy}>
            <div style={styles.sectionLabel}>ACCOUNT CONNECTION</div>
            <h2 id="google-account-heading" style={styles.sectionTitle}>Google Account</h2>
            <p style={styles.text}>Connect Google for faster, simpler sign-in to 9jaWin.</p>
          </div>
        </div>

        <div style={connected || message ? styles.statusRowConnected : error ? styles.statusRowError : styles.statusRow} role="status" aria-live="polite">
          <span style={connected || message ? styles.statusDotConnected : error ? styles.statusDotError : styles.statusDot} aria-hidden="true" />
          <span style={styles.statusText}>{statusLoading ? 'Checking connection…' : connected || message ? 'Connected' : error ? 'Connection needs attention' : 'Not connected'}</span>
        </div>

        {connected && !message && <div style={styles.success} role="status">Google is connected to your 9jaWin account.</div>}
        {message && <div style={styles.success} role="status">{message}</div>}
        {!connected && error && <div style={styles.error} role="alert">{error}</div>}

        {!statusLoading && !connected && (
          <div style={styles.googleAction}>
            <GoogleSignInButton
              mode="link"
              onSuccess={() => { setError(''); setMessage('Google account connected successfully.'); setConnected(true); }}
              onError={(msg) => { setMessage(''); setError(msg); }}
            />
          </div>
        )}
      </section>

      <div style={{textAlign:"center",marginTop:28,color:"#66716d",fontSize:11}}>App version {BUILD_VERSION_TEXT}</div>
    </main>
  );
}

const styles = {
  page:{maxWidth:700,margin:'0 auto',padding:'18px 16px 40px',color:'#fff',background:'#0a0a0a',minHeight:'100vh'},
  header:{display:'flex',alignItems:'center',gap:14,marginBottom:18},
  back:{border:0,background:'transparent',color:'#8d969d',fontWeight:800,cursor:'pointer',padding:0},
  title:{fontSize:22,margin:0,fontWeight:900,color:'#fff'},
  card:{border:'1px solid rgba(67,88,101,.66)',borderRadius:17,padding:18,background:'linear-gradient(145deg,#121c24 0%,#0e161d 100%)'},
  googleCard:{border:'1px solid rgba(67,88,101,.66)',borderRadius:17,padding:'18px 18px 8px',background:'linear-gradient(145deg,#121c24 0%,#0e161d 100%)',boxShadow:'0 8px 22px rgba(0,0,0,.18),inset 0 1px 0 rgba(255,255,255,.025)'},
  googleHeader:{display:'flex',alignItems:'center',gap:12,minWidth:0},
  googleIcon:{width:42,height:42,flex:'0 0 42px',display:'grid',placeItems:'center',borderRadius:12,background:'rgba(0,212,170,.10)',border:'1px solid rgba(0,212,170,.30)',color:'#00d4aa',fontSize:19,fontWeight:900},
  googleHeadingCopy:{minWidth:0},
  sectionLabel:{fontSize:10,color:'#8d969d',letterSpacing:1.4,fontWeight:800,marginBottom:2},
  sectionTitle:{fontSize:18,margin:'0 0 4px',fontWeight:900,color:'#fff'},
  text:{fontSize:13,lineHeight:1.45,color:'#9aa3ab',margin:0},
  statusRow:{display:'flex',alignItems:'center',gap:8,marginTop:16,padding:'9px 10px',borderRadius:10,background:'#0d151c',border:'1px solid rgba(67,88,101,.45)'},
  statusRowConnected:{display:'flex',alignItems:'center',gap:8,marginTop:16,padding:'9px 10px',borderRadius:10,background:'rgba(0,212,170,.08)',border:'1px solid rgba(0,212,170,.30)'},
  statusRowError:{display:'flex',alignItems:'center',gap:8,marginTop:16,padding:'9px 10px',borderRadius:10,background:'rgba(255,77,77,.10)',border:'1px solid rgba(255,77,77,.35)'},
  statusDot:{width:8,height:8,borderRadius:'50%',background:'#8d969d',flex:'0 0 8px'},
  statusDotConnected:{width:8,height:8,borderRadius:'50%',background:'#00d4aa',flex:'0 0 8px'},
  statusDotError:{width:8,height:8,borderRadius:'50%',background:'#ff6b6b',flex:'0 0 8px'},
  statusText:{fontSize:12,fontWeight:800,color:'#b8c0c7'},
  googleAction:{marginTop:4},
  success:{padding:10,borderRadius:10,background:'rgba(0,212,170,.08)',border:'1px solid rgba(0,212,170,.30)',color:'#8de5d3',fontSize:13,marginTop:10,marginBottom:2},
  error:{padding:10,borderRadius:10,background:'rgba(255,77,77,.10)',border:'1px solid rgba(255,77,77,.35)',color:'#fca5a5',fontSize:13,marginTop:10,marginBottom:2},
}
